import styled, { keyframes } from "styled-components";
import backgroundImage from "../../images/fundobg.png";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-image: url(${backgroundImage});
  background-position: 100px;
  background-repeat: no-repeat;
  background-position-x: left;

  img {
    width: 100%;
    height: 300px;
  }

  body {
    font-family: Poppins;
  }

  @media screen and (max-width: 768px) {
    .pagenew {
      margin: 1.5rem;
      margin-top: 5rem;
    }

    .pagenew h2 {
      font-size: 30px;
    }

    .pagenew span {
      font-size: 22px;
    }

    .pagenew p {
      font-size: 13px;
    }
  }
`;

export const PageNew = styled.div`
  color: #06575c;
  align-items: start;
  h2 {
    font-size: 2.8rem;
    font-weight: 700;
  }
  span {
    font-size: 2rem;
    font-weight: 500;
  }

  p {
    color: #3c3c3c;
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const SecondSection = styled.div`
  background-color: #292f45;
  text-align: center;
  padding-bottom: 100px; /* Adicionado: margem inferior para separar do rodapé */

  img {
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

export const Title = styled.h2`
  text-align: center;
  color: white;
  margin-top: 2rem;
  font-size: 30px;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

export const ScrollButton = styled.button`
  position: fixed;
  bottom: 50px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s;
  z-index: 1;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    bottom: 25px;
    width: 50px;
    height: 50px;
    font-size: 16px;
  }
`;

export const Button = styled.button`
  margin-top: 1rem;
  padding: 0.1rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background: none;
  border: 1px solid #007bff;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

const borderAnimation = keyframes`
  0% { border-color: black; }
  25% { border-color: red; }
  50% { border-color: blue; }
  75% { border-color: green; }
  100% { border-color: black; }
`;

export const ButtonGit = styled.button`
  margin-top: 1rem;
  padding: 0.1rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid black;
  border-radius: 15px;
  cursor: pointer;

  animation: ${borderAnimation} 5s infinite;

  transition: background-color 0.3s;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const ButtonDesign = styled.button`
  margin-top: 1rem;
  padding: 0.1rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  color: black;
  background: none;
  border: 1px solid #007bff;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;
export const HighlightsSection = styled.section`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 25px;

  @media screen and (min-width: 768px) {
    justify-content: space-between;
  }
`;

export const HighlightItem = styled.div`
  margin-top: 20px;
  flex: 0 0 calc(50% - 20px);
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
  /* Restante do código */

  .gif {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .gif img {
    width: 50px; /* Ajuste o tamanho do GIF conforme necessário */
    height: auto;
  }

  @media screen and (max-width: 768px) {
    flex-basis: 100%; /* Alteração: ocupa 100% da largura no modo responsivo */
    margin-left: 0; /* Removido o espaçamento lateral no modo responsivo */
    margin-right: 0; /* Removido o espaçamento lateral no modo responsivo */
  }
`;

export const HighlightTitle = styled.h3`
  font-size: 18px;
  color: #555;
`;
export const HighlightDescription = styled.p`
  font-size: 14px;
  color: #777;
  overflow: hidden;
  text-overflow: ellipsis; /* Adiciona reticências (...) para indicar conteúdo cortado */
`;
// Restante do código do componente Home...

export const NewSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 100px; /* Adicione um espaçamento superior se necessário */
  text-align: center;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const NewSectionDesign = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 100px; /* Adicione um espaçamento superior se necessário */
  text-align: center;
  padding-top: 80px;
  background-color: white;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const Image = styled.img`
  width: 600px; /* Ajuste o tamanho da imagem conforme necessário */
  height: auto;
  margin-right: 20px; /* Adicione um espaçamento à direita se necessário */
  max-width: ${(props) =>
    props.maxWidth ||
    "100%"}; /* Adicione a propriedade maxWidth para ajustar o tamanho responsivamente */

  @media screen and (max-width: 768px) {
    margin-right: 0; /* Remova o espaçamento à direita no modo responsivo */
    margin-bottom: 20px; /* Adicione um espaçamento inferior no modo responsivo */
    width: 100%; /* Ajuste a largura para ocupar 100% no modo responsivo */
    max-width: 350px;
    margin-top: 35px;
  }
`;

export const Text = styled.p`
  font-size: 1.8rem; /* Ajuste o tamanho do texto conforme necessário */
  color: white;
  text-align: start;

  @media screen and (max-width: 768px) {
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

export const TextDesign = styled.p`
  font-size: 1.8rem; /* Ajuste o tamanho do texto conforme necessário */
  color: #3a3a39;
  text-align: start;

  @media screen and (max-width: 768px) {
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

export const Paragrafo = styled.p`
  font-size: 0.5;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    margin: 2px;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 700;
  }
`;
export const ParagrafoDesign = styled.p`
  color: #3a3a39;
  font-size: 0.5;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    margin: 2px;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 700;
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const WhatsAppButton = styled.a`
  position: fixed;
  bottom: 40px;
  left: 20px;
  display: flex;
  justify-content: start;
  align-items: start;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 999;
  animation: 1s ${pulseAnimation} infinite;

  @media screen and (max-width: 768px) {
    bottom: 25px;
    width: 15%;
    height: auto;
  }

  img {
    width: 80%;
    height: auto;
  }
`;
